// extracted by mini-css-extract-plugin
export default {"accordion":"filters_accordion__CMdoU","item":"filters_item__Bb9Uu","button":"filters_button__xCJhV","panel":"filters_panel__vckpG"};